import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import Util from 'classes/Util';
import React, { useRef, useState } from "react";
import "./styles.css";
/**
 * @function ExternalIframe
 * @param {STRING} className - Allows us to pass a unique class to each ExternalIframe. 
 * @param {STRING} demo - RXP17|ZLE|TN19|PFM21|CS21 sets the iframe url and height settings to the demo selected
 * @returns {React.Component}
 * @example
 *  <ExternalIframe demo="PFM21"/>
 */
export default function ExternalIframe(props) {
  const className = props.className ?? "";
  let [demo ,setDemo]= useState(null);
  const navigate = useRoute();
  let ref = useRef(null);
  let model = useModel();
  let src = "";
  let iframeContainer = {}; 
  const zleProfileType = props.zleProfileType ?? "";

  window.addEventListener("message", evt => {
    if(evt.data.message === "force-global-route"){
     const { route, state } = evt.data.detail;
  
     navigate(route, { state: state ?? {} });
    }
     
   });
  const isLocal = window.location.host.indexOf("onlinebanktours") === -1 && window.location.host.indexOf("oectours") === -1;
  const getOrigin = !isLocal ? window.location.origin : "https://dev.onlinebanktours.com";
  
  const branding = useModel().branding.options;
 

  if(demo === null && (props.demo === "RXPMW" || props.demo === "RXP22" || props.demo === "RXP17")) {
    const courseBranding = props.demo === "RXPMW" && branding.rxpmw_courseid_abi22 !== null
      ? branding.rxpmw_courseid_abi22 
      : branding.rxp17_courseID_abi22;

    fetch(`${ getOrigin }/bcms/php/deploy/ClassModel.php?b=${model.b}&c=${ courseBranding }`)
      .then(response =>{
        if(response.json){
          return response.json()
        }else{
          return {id:"rxp17"}
        }
       
      } )
      .then((jsonData) => {   
        setDemo (jsonData.id  === "rxp22" ? "RXP22":props.demo );
      })
      .catch((error) => {
        setDemo (demo);
      })
  }
  else if(demo === null) { demo = props.demo; }

  const initializeFrameLoad = src => {

    document.loadFrame = function() {
      if(document.demoLoaded === undefined) {
        document.demoLoaded = src;
        window.parent.document.loadFrame();
      }
    }
  }
  
  switch (demo) {
    case "ORIG19": 
      src = model.demos.ORIG19;
      iframeContainer.orig_container = "true";
      initializeFrameLoad(src);
      let orig19Timer = undefined;

      orig19Timer = setInterval(function() {
        try {          
          ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
          ref.current.height = ref.current.contentWindow.document.querySelector('#app-view').scrollHeight;
        } catch(err) {
          if (ref.current) ref.current.height = 1000;
        }
      }, 10);
      
      break;

    case "ORIG20": 
      src = model.demos.ORIG20;
      iframeContainer.orig_container = "true";
      initializeFrameLoad(src);
      let orig20Timer = undefined;

      orig20Timer = setInterval(function() {
        try {          
          ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
          ref.current.height = ref.current.contentWindow.document.querySelector('#app-view').scrollHeight;
        } catch(err) {
          if (ref.current) ref.current.height = 1000;
        }
      }, 10);
      
      break;

    case "RXP17": 
      src =`${ getOrigin }/click/checkfree/2/pages/paymentCenter/?b=${model.b}&c=${branding.rxp17_courseID_abi22}`;
      iframeContainer.rxp17_container = "true";
      //initializeFrameLoad(src);

      setTimeout(() => {
        try {
          if(window.parent.document.loadFrame !== undefined) {
            window.parent.document.loadFrame();
          }
        }
        catch(e) {}
      }, 1500);
     
      var timer = setInterval(function(){
        try{          
          if(ref.current) {
            ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
            ref.current.height = ref.current.contentWindow.document.querySelector('.container').scrollHeight;		
          }		
        }catch(err){
          if (ref.current ){
            ref.current.height = 1000;
          }

          //window.clearInterval(timer)
        }
      }, 10);
      break;

    case "RXP22": 
      let online;
      const local = `${ getOrigin }/bcms/click/rxp22/?b=${model.b}&c=${branding.rxp17_courseID_abi22}#/paybills`;

      // mabi23 will capture the abi22 payments page and does not need this try/catch code.
      if(!Util.inMabi) {
        // This try/catch code is used for rxp22 captures in the context of abi22, where this iframe src
        // is changed to various pages/tabs. rxp22 won't always appear in the same page.
        try {
          online = window.parent.document && window.parent.document.demoLoaded
            ? window.parent.document.demoLoaded
            : undefined;
        }
        catch(e) { online = undefined; }
      }
if(online && online.indexOf("rxp22") != -1){
   src = !isLocal && online ? online : local;
}else{
  src = local;
}
     

      iframeContainer.rxp22_container = "true";

      initializeFrameLoad(src);

      var timer = setInterval(function(){
        try{       
          if(ref.current) {
            ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
            ref.current.height = ref.current.contentWindow.document.querySelector('#root').scrollHeight;	
          }			
        }catch(err){
          if (ref.current){
            ref.current.height = 1000;
          }

          //window.clearInterval(timer)
        }
      }, 10);
      break;

    case "RXPMW": 
      src = `${ model.demos.RXPMW }#${ props.page ?? "main-view" }`;
      iframeContainer.rxpmw_container = "true";

      //initializeFrameLoad(src);
      setTimeout(() => {
        try {
          if(window.parent.document.loadFrame !== undefined) {
            window.parent.document.loadFrame();
          }
        }
        catch(e) {}
      }, 1500);
     
      var timer = setInterval(function(){
        try{          
          ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
          ref.current.contentWindow.document.querySelector('.page-top-nav').style.display = "none";
          ref.current.height = ref.current.contentWindow.document.querySelector('.container').scrollHeight;				
        }catch(err){
          if (ref.current ){
            ref.current.height = 1000;
          }

          //window.clearInterval(timer)
        }
      }, 10);
      break;    

    case "ZLE": 
    let page = "#send-money";
    if(Util.inMabi) {
      page ="#home"
    }

      // START: Branding determines if ZLE loads standalone or inside RXP17 or RXPMW.
      let howIsZLEPresentedBranding = branding.present_zelle_abi22 === "undefined" ? "ABI22" : branding.present_zelle_abi22;
      howIsZLEPresentedBranding = howIsZLEPresentedBranding.toLowerCase();

      // Check if "CheckFree" is set.
      if(howIsZLEPresentedBranding === "checkfree") {
        
        // Bid 126 can route to rxp17 payment center in mobile. 
        // This is the only client that currently navigates to rxp17 in mobile so this if statement was added. 
        if(props.RXP17LandingPage === "paymentCenter") {
          let rxp17PagePath = "paymentCenter/"
          src =`${ getOrigin }/click/checkfree/2/pages/${ rxp17PagePath }?b=${ model.b }&c=${ branding.rxp17_courseID_abi22 }`;
        
        // Bid 126 can route to rxp17 zelle in mobile. 
        // This is the only client that currently navigates to rxp17 in mobile so this if statement was added. 
        } else if(props.RXP17LandingPage === "zelle") {
          let rxp17PagePath = "popmoney.php"
          src =`${ getOrigin }/click/checkfree/2/pages/${ rxp17PagePath }?b=${ model.b }&c=${ branding.rxp17_courseID_abi22 }`;

        // Else, use conditions for all other bids.
        } else {
          if(window.innerWidth <= 750) {
            src =`${ getOrigin }/bcms/click/checkfreeMobileWeb/demo.php?b=${ model.b }&c=${ branding.rxpmw_courseid_abi22 }#person-to-person-page`;
          } else {
            let rxp17PagePath = "popmoney.php";
            if(props.RXP17LandingPage === "paymentCenter") rxp17PagePath = "paymentCenter/";
            src =`${ getOrigin }/click/checkfree/2/pages/${ rxp17PagePath }?b=${ model.b }&c=${ branding.rxp17_courseID_abi22 }`;
          }
        }

      // Else "ABI22" is set.
      } else {
        // Prop "zleProfileType" and the course id will determine if "personal" or "business" zelle is shown.
        // Previously, only the url like "/changeProfile/personal" 
        // or "/changeProfile/business" would determine that.
     
        const zleCourseID = zleProfileType === "personal" ? branding.zle_courseID_abi22 : branding.zlebusiness_cid_abi22;
        src =`${ getOrigin }/bcms/click/zelle/?b=${ model.b }&c=${ zleCourseID }${ page }`;
      }
      // END: Branding determines if ZLE loads standalone or inside RXP17 or RXPMW.

      iframeContainer.zle_container = "true";

      //initializeFrameLoad(src); Add Back after zelle gets a trigger implmeneted
      // Remove timeout once the trigger is implemented within zelle
      setTimeout(() => {
        try{ 
        if(window.parent.document.loadFrame !== undefined) {
          window.parent.document.loadFrame();
        }
      }catch(e){

      }
      }, 1500);

      var timer = setInterval(function(){
        try{          
          ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
          ref.current.height = 1000;			
        }catch(err){
          if (ref.current ){
            ref.current.height = 1000;
          }

          //window.clearInterval(timer)
        }
      }, 10);
      break;

    case "TN19": 
      src = model.demos.TN19;
      iframeContainer.tn19_container = "true";

      //initializeFrameLoad(src);

      // START: Temporary code until the method gets called in TN19 instead.
      setTimeout(() => {
        try {
          if(window.parent.document.loadFrame !== undefined) {
            window.parent.document.loadFrame();
          }
        }
        catch(e) {}
      }, 1500);
      // END: Temporary code until the method gets called in TN19 instead.


      var timer = setInterval(function(){
        try{          
          ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
          ref.current.height = ref.current.contentWindow.document.querySelector('#app-view').scrollHeight;				
        }catch(err){
          if (ref.current ){
            ref.current.height = 1000;
          }

          //window.clearInterval(timer)
        }
      }, 10);
      break;

    case "TNLegacy":
      src = `${ window.location.origin }/click/transfernow/1/?b=${ model.b }&c=${ model.branding.options.tn19_courseID_abi22 }`;
      iframeContainer.tnLegacy_container = "true";

      initializeFrameLoad(src);
      
      setInterval(function(){
        try {
          ref.current.contentWindow.document.querySelector("html").style.overflow = "hidden";
          ref.current.height = ref.current.contentWindow.document.querySelector("#app-view").scrollHeight;
        } catch(err) {
          if(ref.current) {
            ref.current.height = 1000;
          }
        }
      }, 10);
      break;

    case "PFM21": 
      src = model.demos.PFM21;
      iframeContainer.pfm21_container = "true";

      //initializeFrameLoad(src);
      setTimeout(() => {
        if(window.parent.document.loadFrame !== undefined) {
          window.parent.document.loadFrame();
        }
      }, 1500);
      var timer = setInterval(function(){
        try{          
          ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
          ref.current.height = ref.current.contentWindow.document.querySelector('#app-view').scrollHeight;				
        }catch(err){
          if (ref.current ){
            ref.current.height = 1000;
          }

          //window.clearInterval(timer)
        }
      }, 10);
      break;
      case "PFM25": 
      src = model.demos.PFM25;
      iframeContainer.pfm25_container = "true";

      //initializeFrameLoad(src);
      setTimeout(() => {
        if(window.parent.document.loadFrame !== undefined) {
          window.parent.document.loadFrame();
        }
      }, 1500);
      var timer = setInterval(function(){
        try{       
          ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
          ref.current.height = ref.current.contentWindow.document.querySelector('#root').scrollHeight;		
        }catch(err){
          if (ref.current ){
            ref.current.height = 1000;
          }
          //window.clearInterval(timer)
        }
      }, 10);
      break;

    case "CS21": 
      src = model.demos.CS21;
      iframeContainer.cs21_container = "true";

      initializeFrameLoad(src);

      let csTimer = undefined;

      if(!(window.innerWidth <= 625)) {
        csTimer = setInterval(function(){
          try{  
            if(props.hideOverflow !== true){
              ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
            }        
           
            ref.current.height = ref.current.contentWindow.document.querySelector('#app-view').scrollHeight;
          }catch(err){
            if (ref.current ){
              ref.current.height = 1000;
            }
          }
        }, 10);
      }
      break;

    case "CHW23":
      src = model.demos.CHW23;
      iframeContainer.chw23_container = "true";
      const chwLocal = `${ getOrigin }/bcms/click/chw23/?b=${model.b}&c=${branding.chw23_courseid_abi22}#/home/recenttransactions`;
     let chwOnline;

      try {
        chwOnline = window.parent.document && window.parent.document.demoLoaded
          ? window.parent.document.demoLoaded
          : undefined;
      }
      catch(e) { chwOnline = undefined; }
      if(chwOnline && chwOnline.indexOf("chw23") != -1){
        src = !isLocal && chwOnline ? chwOnline : chwLocal;
     }else{
       src = chwLocal;
     }
     
      initializeFrameLoad(src);
      
      setInterval(function() {
        try {
          ref.current.contentWindow.document.querySelector("html").style.overflow = "hidden";
          ref.current.height = ref.current.contentWindow.document.querySelector("#root").scrollHeight;
        } catch(err) {
          if(ref.current) {
            ref.current.height = 1000;
          }
        }
      }, 10);
      break;

    case "CH21":
      src = model.demos.CH21 + "#card-details-page";
      iframeContainer.ch21_container = "true";

      setTimeout(() => {
        try {
          if(window.parent.document.loadFrame !== undefined) {
            window.parent.document.loadFrame();
          }
        }
        catch(e) {}
      }, 1500);
      
      setInterval(function() {
        try {
          ref.current.contentWindow.document.querySelector("html").style.overflow = "hidden";
          ref.current.height = ref.current.contentWindow.document.querySelector("#app-view").scrollHeight;
        } catch(err) {
          if(ref.current) {
            ref.current.height = 1000;
          }
        }
      }, 10);
      break;

    case "CFC25":
      src = model.demos.CFC25;
      iframeContainer.cfc25_container = "true";

      const cfcLocal = `${ getOrigin }/bcms/click/cfc25/?b=${ model.b }&c=${ branding.cfc25_courseID_abi22 }`;
      let cfcOnline;

      try {
        cfcOnline = window.parent.document && window.parent.document.demoLoaded
          ? window.parent.document.demoLoaded
          : undefined;
      } catch(e) { cfcOnline = undefined; }

      if(cfcOnline && cfcOnline.indexOf("cfc25") != -1) {
        src = !isLocal && cfcOnline ? cfcOnline : cfcLocal;
      }
      else {
        src = cfcLocal;
      }

      initializeFrameLoad(src);

      setTimeout(() => {
        if(window.parent.document.loadFrame !== undefined) {
          window.parent.document.loadFrame();
        }
      }, 1500);

      setInterval(function(){
        try{       
          ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
          ref.current.height = ref.current.contentWindow.document.querySelector('#root').scrollHeight;	
        
        }catch(err){
          if (ref.current ){
            ref.current.height = 1000;
          }
        }
      }, 10);

      break;

    default:
      console.log(demo === null ? "Waiting for data fetch" : `${ demo } is an invalid demo`)
  }
 
  return <iframe className={`external-iframe ${props.className||""}`} ref={ref}  src={src} {...iframeContainer}/>
}